export interface IEntranceTypeOption {
  label: string;
  value: EInternalEntranceType | null;
}

export enum EInternalEntranceType {
  Courtyard = 'courtyard',
  Street = 'street',
}
